import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default Vue.component('checkbox', {
  template: require('./template.html'),
  name: 'checkbox',
  computed: {
    ...mapGetters(['viewport', 'activeDroplet']),
    allColumns() {
      let list = [];
      const droplet = this.activeDroplet;
      if (droplet.rows) {
        _.forEach(this.activeDroplet.rows,
          row => _.forEach(row.columns, column => list.push(column)));
      }
      if (droplet.cards) {
        list = list.concat(droplet.cards);
      }
      if (droplet.columns) {
        list = list.concat(droplet.columns);
      }
      return { list };
    },
  },
  props: ['option', 'active-state', 'dom-nodes'],
  data() {
    return {
      display: {},
      debTime: 250,
      innerDomNodes: {},
    };
  },
  watch: {
    viewport() {
      this.setInitialValue();
    },
  },
  created() {
    // setup defaults from payload models
    _.forOwn(this.option.payload.models, (model) => {
      this.$set(this.display, model.name, model.default);
    });
    // then check for previous values
    this.setInitialValue();
  },
  methods: {
    setInitialValue() {
      const option = this.option;
      this.display[option.payload.models.value.name] = this.getValDisplay(option.payload);
    },
    changeCSS(params) {
      const checked = this.display[this.option.payload.models.value.name];
      const payload = {};
      payload.drp = this.activeDroplet;
      payload.val = this.buildVal(checked);
      payload.selector = params.selector;
      payload.viewport = this.viewport;
      // draw active state in selector if needed
      if (params.activeState) {
        payload.selector = this._buildStateSelector({
          selector: params.selector,
          activeState: this.activeState,
        });
      }
      _.forEach(params.properties, (property) => {
        payload.property = property;
        this.$emit('check-legacy-styles', payload);
        this.$store.dispatch('changeDropletCss', payload);
      });
      this.$emit('css-generator', this.cssPayload(), this.option.plugin);
      if (this.option.observer) {
        this.$emit('emit-observer');
      }
      this.$emit('update-changes', true);
    },
    cssPayload() {
      let payload = false;
      if (this.option.payload.useColumns) {
        payload = {
          key: 'drps',
          value: [...this.allColumns.list, this.activeDroplet],
        };
      }
      return payload;
    },
    getValDisplay(params) {
      let shown = this.option.payload.models.value.defaultDisplay;
      const useRoot = this.option.$el === 'root';
      const $root = this.domNodes.$dropletRow;
      const $el = useRoot ? $root : $root.querySelectorAll(this.option.$el)[0];
      const rule = this._rule(
        this.activeDroplet,
        this.viewport,
        params.selector,
        params.properties[0],
      );
      if ((rule.status === 'not-present' || rule.status === 'default') && $el) {
        const styles = window.getComputedStyle($el);
        shown = styles.display;
      }
      if (rule.status === 'inherit') {
        shown = rule.prop.desktop;
      }
      if (rule.status === 'custom') {
        shown = rule.prop[this.viewport];
      }
      return shown === this.option.payload.models.value.option;
    },
    buildVal(checked) {
      let value = this.option.payload.models.value.defaultDisplay;
      if (checked) {
        value = this.option.payload.models.value.option;
      }
      return value;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/style-sidebar/options/checkbox/index.js